module.exports = __webpack_public_path__ + "2b0823211c60bbe598f514fe0a7331c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/storyhead/imgs/1.jpg
// module id = 399
// module chunks = 0